import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppContextProvider from './contexts/AppProvider'
import TagManager from 'react-gtm-module'
import LocalizationProvider from './localization/LocalizationProvider'
import { AppStore } from './Store.js'
import Language from './models/Language';

const tagManagerArgs = {
  gtmId: 'GTM-KZCLTMV'
}

TagManager.initialize(tagManagerArgs)
let searchParams = decodeURIComponent(window.location.search)

localStorage.setItem("lang", 'he');
if (searchParams.includes('localize-en')) {
  AppStore.language = Language.en;
  localStorage.setItem("lang", 'en');
  document.querySelector('body').classList.add('ltr');
} else if (searchParams.includes('localize-ar')) {
  AppStore.language = Language.ar;
  localStorage.setItem("lang", 'ar');
}


ReactDOM.render(
  <React.StrictMode>
  <AppContextProvider>
  <LocalizationProvider>
  
      <App />
      </LocalizationProvider>
    </AppContextProvider>


  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
